import { Typography, Col, Row } from 'antd';
import { type VFC, useState } from 'react';
import { type HardwareDataItem, HardwaresSelect } from 'components/form/select/HardwaresSelect';
import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { Icon } from '@/components/icon';
import { useTheme } from 'styled-components';
import { useUpdateHardware } from 'api/hooks';
import { Form, Modal } from 'components';

const { Text } = Typography;

interface CopyHWQueryModalProps {
  readonly hardware: SerializedHardware;
  readonly onHide: () => void;
  readonly onSuccess: () => void;
}

export const CopyHWQueryModal: VFC<CopyHWQueryModalProps> = ({ hardware, onHide, onSuccess }) => {
  const theme = useTheme();
  const [selectedHardware, setSelectedHardware] = useState<HardwareDataItem | undefined>(undefined);

  const { mutateAsync: updateHardware, isLoading } = useUpdateHardware(onSuccess);

  const handleOk = async () => {
    await updateHardware({
      id: hardware.id,
      values: { query: selectedHardware?.query },
    });
  };

  return (
    <Modal
      centered
      open
      confirmLoading={isLoading}
      okButtonProps={{ onClick: handleOk, loading: isLoading }}
      okText="Copy"
      title="Copy query"
      onCancel={onHide}
    >
      <Form layout="vertical" onFinish={handleOk}>
        <Form.Item label="Hardware to copy from">
          <HardwaresSelect
            filterHardwares={hardwarePredicate =>
              Boolean(hardwarePredicate.query) &&
              hardwarePredicate.category === hardware.category &&
              hardwarePredicate.id !== hardware.id
            }
            onHardwareChange={value => setSelectedHardware(value)}
          />
        </Form.Item>
      </Form>
      <Row>
        <Col span={2} style={{ alignSelf: 'center' }}>
          <Icon iconString="infoCircle" style={{ fontSize: 24, color: theme.color.status.info }} />
        </Col>
        <Col span={22}>
          <Text type="secondary">
            This action will completely replace the current query on hardware with the one from selected hardware. If
            you wish to continue, click Copy.
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};
